import { debug, george, i18n, observer, pr, React, RouteComponentProps, theme, toJS, ui } from "aaa";
import { TopBackgroundColor } from "components/util/TopBackgroundColor";
import { displayPinSignPut } from "network/mockResponses";
import { pushRoute } from "stores/RouterFunctions";
import { amountToCurrencyString } from "types/amount";
import { ISigningResponse } from "types/signing";
import { A11yRefocus } from "../../common/A11yRefocus";
import { FormattedAmount } from "../../util/FormattedAmount";
import PinResetStore from "../stores/PinResetStore";

const USE_MOCK_RESPONSE = false;

/**
 * Component for PinReset main screen
 */
@i18n.injectIntl
@observer
export class PinResetLandingPage extends React.Component<RouteComponentProps<{}> & {
    pinResetStore: PinResetStore
}> {
    onResetPin = async () => {
        // check if fees and card was loaded
        if (this.props.pinResetStore.cardStore.cardFees) {
            try {
                await this.props.pinResetStore.resetPin();
                pushRoute("/pin-reset/signing");
            } catch (e) {
                debug.log("### onResetPin() failed", e);
                pushRoute("/error");
            }
        }
    }

    renderBody() {
        let feeComponent: any = null;
        const fee = this.props.pinResetStore.pinRestoreFee;

        if (fee && fee.value > 0) {
            feeComponent = <FormattedAmount amount={this.props.pinResetStore.pinRestoreFee} />;
        }

        return (
            <div style={{ paddingBottom: theme.ACTION_BUTTON_HEIGHT }}>
                <pr.SigningLabelContainer>

                    <div style={{ textAlign: "center" }}>
                        <A11yRefocus>
                            <pr.LandingPageTitle>{ui.__("pin.order.title")}</pr.LandingPageTitle>
                        </A11yRefocus>

                        <pr.LandingPageSubtitle>
                            {ui.__("pin.order.body.subTitle")}
                        </pr.LandingPageSubtitle>

                    </div>

                    <pr.BoldLabel style={{ color: theme.customColors.georgeGradient2, margin: theme.MARGIN_SMALL, textAlign: "center" }}>
                        {feeComponent}
                    </pr.BoldLabel>

                    <pr.P_14_CONTENT style={{ textAlign: "left" }}>
                        <i18n.FormattedHTMLMessage
                            id={(fee && fee.value > 0) ? "pin.order.body" : "pin.order.body.noFee"}
                            values={{
                                fee: amountToCurrencyString(fee),
                                product: this.props.pinResetStore.getProductString()
                            }}
                        />
                    </pr.P_14_CONTENT>
                </pr.SigningLabelContainer>
            </div>
        );
    }

    /**
     * Gradient plus image
     */
    renderHeader(imageName: string) {
        return (
            <pr.HeaderBackground
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <img
                    src={require("../../../assets/" + imageName)}
                    height={`${theme.HEADER_ICON_SIZE}px`}
                    alt=""
                />
            </pr.HeaderBackground>
        );
    }

    render() {
        if (!this.props.pinResetStore) {
            return (<pr.P_16_CONTENT>"no card id provided"</pr.P_16_CONTENT>);
        } else {
            const card = toJS(this.props.pinResetStore.cardStore.card);
            const disableButton = !card ||
                this.props.pinResetStore.cardIsLoading ||
                this.props.pinResetStore.resetPinIsLoading;

            const loading = this.props.pinResetStore.cardIsLoading;
            return (
                <george.LandingBackground>
                    <TopBackgroundColor />
                    {this.renderHeader("illustration_PIN_Kreis.svg")}
                    {!loading &&
                        <div style={{ marginBottom: "36px" }}>
                            {this.renderBody()}
                        </div>
                    }

                    <george.LoadingIndicator isLoading={loading} height={ui.windowHeight - theme.HEADER_HEIGHT - theme.ACTION_BUTTON_HEIGHT} />
                    <george.ActionButton
                        messageId="pin.order.button.title"
                        disableButton={disableButton}
                        onClick={() => {
                            if (USE_MOCK_RESPONSE) {
                                // For testing -> directly display mock data
                                this.props.pinResetStore.signingResponse = displayPinSignPut as ISigningResponse;
                            } else {
                                // Trigger pin reset
                                this.onResetPin();
                            }
                        }}
                    />
                </george.LandingBackground>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/pin/views/PinResetLandingPage.tsx